module.exports = __webpack_public_path__ + "static/media/A futuristic space station orbiting a distant planet.a40dedd8.jpeg";